<template>
  <li>
    <button type="button" class="uk-accordion-title">{{ displayNumber }}. Side Cabinets</button>
    <div class="uk-accordion-content">
      <!-- Side Cabinets -->
      <div class="cabinets-container">
        <ul uk-switcher="connect: .uk-switcher.right-cabinet" class="uk-flex uk-flex-middle cabinet-toggles">
          <li v-for="size in size_options" :key="'cab_size_' + size"><a href="#">{{ size }}"</a></li>
        </ul>
        <ul class="uk-switcher right-cabinet">
          <li v-for="(cabSize, size) in cabinet_sizes" :key="'cab_size_section_' + size">
            <div class="cabinet-list">
              <p>Add a right side cabinet</p>
              <div class="uk-child-width-1-3@m uk-grid-collapse" uk-height-match=".cabinet-header" uk-grid role="radiogroup" aria-label="Right side cabinet">
                <template v-for="(cabinet, cabCount) in cabSize">
                  <div v-if="cabCount < 3" :key="'cabinet_rt_' + '_' + size + '_' + cabinet.id">
                    <button type="button" class="cabinet" :class="{'selected': cabinetIsSelected('right', cabinet)}" role="radio" :aria-checked="cabinetIsSelected('right', cabinet) ? 'true' : 'false'" :aria-label="`Right ${cabinet.cabinet_type.name}`" @click.prevent="selectRightCabinet(cabinet, size, cabCount)">
                      <div class="cabinet-header">
                        <p class="cabinet-name">{{ cabinet.cabinet_type.name }}</p>
                        <p class="extra-price">{{ cabinetPrice(cabinet, size) }}</p>
                      </div>
                      <img :src="cabinetImage(cabinet, 'right')" alt="">
                    </button>
                  </div>
                </template>
              </div>
            </div>
          </li>
        </ul>
        <ul uk-switcher="connect: .uk-switcher.left-cabinet" class="uk-flex uk-flex-middle cabinet-toggles">
          <li v-for="size in size_options" :key="'cab_size_' + size"><a href="#">{{ size }}"</a></li>
        </ul>
        <ul class="uk-switcher left-cabinet">
          <li v-for="(cabSize, size) in cabinet_sizes" :key="'cab_size_section_' + size">
            <div class="cabinet-list">
              <p>Add a left side cabinet</p>
              <div class="uk-child-width-1-3@m uk-grid-collapse" uk-height-match=".cabinet-header" uk-grid role="radiogroup" aria-label="Left side cabinet">
                <template v-for="(cabinet, cabCount) in cabSize">
                  <div v-if="cabCount < 3" :key="'cabinet_lt_' + '_' + size + '_' + cabinet.id">
                    <button type="button" class="cabinet" :class="{'selected': cabinetIsSelected('left', cabinet)}" role="radio" :aria-checked="cabinetIsSelected('left', cabinet) ? 'true' : 'false'" :aria-label="`Left ${cabinet.cabinet_type.name}`" @click.prevent="selectLeftCabinet(cabinet, size, cabCount)">
                      <div class="cabinet-header">
                        <p class="cabinet-name">{{ cabinet.cabinet_type.name }}</p>
                        <p class="extra-price">{{ cabinetPrice(cabinet, size) }}</p>
                      </div>
                      <img :src="cabinetImage(cabinet, 'left')" alt="">
                    </button>
                  </div>
                </template>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </li>
</template>

<script>

import {mapState} from "vuex";

export default {
  name: "SideCabinets",

  props: {
    displayNumber:{
      type: Number,
      default: 3
    }
  },
  components: {},
  data() {
    return {
      //cabinetOptions:{}
    }
  },
  mounted() {

  },
  methods: {
    cabinetPrice(cabinet, size){
      const width = `${size}.00`;
      const woodID = this.selected_wood.id;
      let price = null;
      // loop through all pricing
      for(let i in cabinet.cabinet_type.prices){
        const row = cabinet.cabinet_type.prices[i];
        if(row.width == width){
          for(let w in row.woods){
            if(woodID == row.woods[w].id){
              price = row;
              break;
            }
          }
        }
        if(price != null) break;
      }

      let finalPrice = parseFloat(price.price);
      if(this.selected_finish != null){
        let wallbedUpcharge = this.selected_finish.grade.wallbed_upcharge;
        if(wallbedUpcharge != null){
          finalPrice = finalPrice + parseFloat(wallbedUpcharge);
        }
      }

      // use this price
      return this.$options.filters.diffcurrency(finalPrice);
    },
    selectLeftCabinet(cabinet, size, index){
      if(this.selected_cabinet_left && this.selected_cabinet_left.id == cabinet.id){
        //deselect it (clear the item)
        this.$store.commit('setSelectedCabinetSize',{side : 'left' , size : "none"});
        this.$store.commit('setSelectedCabinetStyle',{side : 'left' , style : null});
        this.$store.commit('setSelectedCabinetLeft', null);
      }
      else {
        this.$store.commit('setSelectedCabinetSize',{side : 'left' , size : size});
        this.$store.commit('setSelectedCabinetStyle',{side : 'left' , style : index});
        this.$store.commit('setSelectedCabinetLeft', cabinet);
      }
    },
    selectRightCabinet(cabinet, size, index){
      if(this.selected_cabinet_right && this.selected_cabinet_right.id == cabinet.id){
        //deselect it (clear the item)
        this.$store.commit('setSelectedCabinetSize', {side: 'right', size: "none"});
        this.$store.commit('setSelectedCabinetStyle', {side: 'right', style: null});
        this.$store.commit('setSelectedCabinetRight', null);
      }
      else {
        this.$store.commit('setSelectedCabinetSize', {side: 'right', size: size});
        this.$store.commit('setSelectedCabinetStyle', {side: 'right', style: index});
        this.$store.commit('setSelectedCabinetRight', cabinet);
      }
    },
    cabinetIsSelected(side, cabinet){
      if(side == "left"){
        return this.selected_cabinet_left && this.selected_cabinet_left.id == cabinet.id;
      } else if (side == "right"){
        return this.selected_cabinet_right && this.selected_cabinet_right.id == cabinet.id;
      }
    },
    cabinetImage(cabinet, side){
      //src=""
      let blueprint = cabinet.blueprints && cabinet.blueprints[0] ? cabinet.blueprints[0]:null;
      let imagePath = blueprint ? blueprint.image.webPath + '/500/500?black=1&nocrop=1':"/wp-content/themes/wallbeds/img/Remington-Side-Cabinets7.jpg";
      if(side == "left"){
        imagePath += "&x-invert=1";
      }
      return imagePath;
    }
  },
  computed:{
    ...mapState({
      cabinet_sizes : state => state.cabinet_sizes,
      selected_wood : state => state.selected_wood,
      selected_finish : state => state.selected_finish,
      selected_left_cabinet_size : state => state.selected_left_cabinet_size,
      selected_left_cabinet_style : state => state.selected_left_cabinet_style,
      selected_cabinet_left : state => state.selected_cabinet_left,
      selected_right_cabinet_size : state => state.selected_right_cabinet_size,
      selected_right_cabinet_style : state => state.selected_right_cabinet_style,
      selected_cabinet_right : state => state.selected_cabinet_right,
      selected_headboard : state => state.selected_headboard,
      depth_prices : state => state.depth_prices,
      size_options :  state => state.cabinet_size_options
    })
  },
  watch: {}
}
</script>

<style scoped>

</style>